<template>
  <el-header>
    <!-- Бегущая строка-объявление над шапкой (управляется в настройках) -->
    <HeaderTicker />

    <el-affix v-if="$device.isDesktop">
      <div>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          :ellipsis="false"
          :popper-offset="16"
          @select="handleSelect"
        >
          <el-menu-item index="0" style="padding: 0px 5px;">
            <NuxtLink to="/">
              <img
                height="60"
                src="/img/logo_smiledell.svg"
                alt="Логотип Smail Dell"
              />
            </NuxtLink>
          </el-menu-item>

          <ClientOnly>
            <div v-if="!isHeadOverflow" class="header-contacts">
              <span style="white-space: nowrap">
                <span style="font-weight: 300">Тел:</span
                ><span style="font-weight: 500"><a href="tel:+79052860984" style="color: var(--el-text-color-primary);">+7 (905) 286-09-84</a></span>
              </span>
              <span style="white-space: nowrap">
                <span style="font-weight: 300">Email:</span
                ><span style="font-weight: 500">opt@smaildell.ru</span>
              </span>
            </div>

            <div class="header-search-slot">
              <HeaderSearch />
            </div>
          </ClientOnly>
          <el-menu-item index="1">
            <NuxtLink to="/">О компании</NuxtLink>
          </el-menu-item>
          <el-menu-item index="2">
            <NuxtLink to="/catalog">Каталог</NuxtLink>
          </el-menu-item>
          <el-menu-item index="3">
            <NuxtLink to="/prices">Цены</NuxtLink>
          </el-menu-item>
          <el-menu-item index="4">
            <NuxtLink to="/contact">Контакты</NuxtLink>
          </el-menu-item>
          <el-menu-item v-if="isStaff" index="5">
            <NuxtLink to="/private" style="color: var(--sd-red)">Админка</NuxtLink>
          </el-menu-item>

          <ClientOnly>
            <div class="header-account">
              <ThemeSwitch />
              <CartButton />
              <!-- Кабинет: иконка с именем и стрелкой открывает меню — заказы,
                   админка, выход. Выход убран в меню, чтобы не занимать место -->
              <el-dropdown
                v-if="currentUser"
                trigger="click"
                placement="bottom-end"
                @command="onUserCommand"
              >
                <button type="button" class="header-user">
                  <el-icon><User /></el-icon>
                  <span class="header-user__name">{{ userLabel }}</span>
                  <el-icon class="header-user__arrow"><ArrowDown /></el-icon>
                </button>
                <template #dropdown>
                  <div class="header-user__email">{{ userEmail }}</div>
                  <el-dropdown-menu>
                    <el-dropdown-item command="orders" :icon="Tickets">Мои заказы</el-dropdown-item>
                    <el-dropdown-item v-if="isStaff" command="admin" :icon="Setting">
                      <span class="header-user__admin">Админка</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" :icon="SwitchButton" divided>Выйти</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <NuxtLink v-else to="/login" class="header-user">
                <el-icon><User /></el-icon>
                <span>Войти</span>
              </NuxtLink>
            </div>
          </ClientOnly>
        </el-menu>

        <!-- Вторая строка под шапкой: здесь всегда рекламная фраза про опт,
             а при нехватке ширины (isHeadOverflow) сюда же уходят Тел/Email
             вместо того, чтобы просто скрываться -->
        <ClientOnly>
          <div class="header-subline">
            <div class="header-subline__left">
              <template v-if="isHeadOverflow">
                <span class="header-subline__contact">
                  <span style="font-weight: 300">Тел:</span>
                  <a href="tel:+79052860984" style="color: inherit; font-weight: 500;">+7 (905) 286-09-84</a>
                </span>
                <span class="header-subline__sep">·</span>
                <span class="header-subline__contact">
                  <span style="font-weight: 300">Email:</span>
                  <span style="font-weight: 500">opt@smaildell.ru</span>
                </span>
                <span class="header-subline__sep">·</span>
              </template>
              <span class="header-subline__promo">Индивидуальные условия для опта от производителя</span>
            </div>

            <!-- Город здесь, а не в основной строке: там и так тесно -->
            <CitySelect />
          </div>
        </ClientOnly>
      </div>
    </el-affix>
    <div v-else>
      <p
        style="
          font-size: 22px;
          text-align: center;
          padding: 0;
          margin: 0;
          font-weight: 800;
        "
      >
        Smail Dell
      </p>

      <div class="mobile-search-row">
        <HeaderSearch />
        <ClientOnly>
          <ThemeSwitch />
          <CartButton />
          <!-- На телефоне меню не поместится: значок ведёт в кабинет
               (там же кнопка «Выйти») или на страницу входа -->
          <NuxtLink
            :to="currentUser ? '/account' : '/login'"
            class="mobile-user"
            :aria-label="currentUser ? 'Личный кабинет' : 'Войти'"
          >
            <el-icon><User /></el-icon>
          </NuxtLink>
        </ClientOnly>
      </div>

      <ClientOnly>
        <div class="mobile-city-row">
          <CitySelect />
        </div>
      </ClientOnly>

      <div style="display: flex; justify-content: center">
        <NuxtLink to="/" class="menu-link">О компании</NuxtLink>
        <span class="menu-spacer">|</span>
        <NuxtLink to="/catalog" class="menu-link">Каталог</NuxtLink>
        <span class="menu-spacer">|</span>
        <NuxtLink to="/prices" class="menu-link">Цены</NuxtLink>
        <span class="menu-spacer">|</span>
        <NuxtLink to="/contact" class="menu-link">Контакты</NuxtLink>
      </div>

      <div
        style="
          white-space: nowrap;
          text-align: right;
          border-bottom: 1px solid var(--el-border-color-light);
        "
      >
        <span style="font-weight: 300">Тел:</span>
        <span style="font-weight: 500"><a href="tel:+79052860984" style="color: var(--el-text-color-primary);">+7 (905) 286-09-84</a></span>
      </div>
    </div>
  </el-header>
</template>

<script setup>
import { ref } from "vue";
import { useWindowSize } from "@vueuse/core";
import { User, ArrowDown, Tickets, Setting, SwitchButton } from "@element-plus/icons-vue";

const router = useRouter(); // Инициализируем router для навигации
const route = useRoute();
const { width } = useWindowSize();

const currentUser = useAuthUser();
// Ссылка в админку — всем сотрудникам: и ADMIN, и MANAGER
const isStaff = useStaff();
const { logout } = useAuth();

const isHeadOverflow = ref(false)

watchEffect(() => {

  isHeadOverflow.value = width.value < 900 ? true : false;
});

// Выбор текущего раздела при загрузке страницы
const activeIndex = ref("1");
if (route.fullPath.startsWith("/prices")) {
  activeIndex.value = "3";
} else if (route.fullPath.startsWith("/contact")) {
  activeIndex.value = "4";
} else if (route.fullPath.startsWith("/catalog")) {
  activeIndex.value = "2";
} else if (route.fullPath.startsWith("/private")) {
  activeIndex.value = "5";
} else {
  activeIndex.value = "1";
}

// показывет index текущего раздела
const handleSelect = (key, keyPath) => {
  //console.log(key, keyPath)
};

// На кнопке — имя из профиля (первое слово), а если его нет — «Кабинет»
const userLabel = computed(
  () => String(currentUser.value?.name ?? "").trim().split(/\s+/)[0] || "Кабинет"
);
const userEmail = computed(() => currentUser.value?.email || currentUser.value?.login || "");

const onUserCommand = (command) => {
  if (command === "orders") router.push("/account");
  else if (command === "admin") router.push("/private");
  else if (command === "logout") handleLogout();
};

// Обработчик выхода с навигацией
const handleLogout = async () => {
  try {
    await logout();
    await router.push("/"); // Перенаправление на главную страницу
  } catch (error) {
    console.error("Ошибка при выходе:", error);
  }
};
</script>

<style scoped>
/* У el-header по умолчанию фиксированная высота (--el-header-height: 60px);
   из-за .header-subline (вторая строка) реальная высота шапки больше,
   поэтому height должен подстраиваться под контент, а не быть фиксированным
   — иначе следующий блок страницы наезжает на вторую строку */
.el-header {
  height: auto;
}

/* Блок "Тел/Email" в самой шапке — показывается только когда есть место
   (v-if="!isHeadOverflow"), иначе переезжает в .header-subline ниже */
.header-contacts {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: none;
  white-space: nowrap;
}

/* Поиск в шапке: центрирован в свободном пространстве между логотипом
   с контактами (слева) и разделами сайта (справа); ширина по умолчанию
   больше прежней примерно на 50%, но сжимается, если места не хватает. */
.header-search-slot {
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  width: clamp(270px, 33vw, 480px);
  margin: 0 auto;
  padding: 0 8px;
}

/* Город на мобильном — отдельной строкой: в строке с поиском места нет */
.mobile-city-row {
  display: flex;
  justify-content: center;
  padding-bottom: 4px;
}

/* Мобильная ветка: поиск и корзина в одной строке */
.mobile-search-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
}

.mobile-search-row > :first-child {
  flex: 1 1 auto;
  min-width: 0;
}

/* Кнопка кабинета — в тех же цветах, что прежний значок с логином */
.header-user {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px;
  /* Полупрозрачная, как сама шапка (rgba 0.8 + размытие): сплошная плашка
     выглядела наклейкой поверх просвечивающего каталога */
  border: 1px solid color-mix(in srgb, var(--el-color-primary-light-8) 90%, transparent);
  border-radius: 6px;
  background-color: color-mix(in srgb, var(--el-color-primary-light-9) 55%, transparent);
  color: var(--el-color-primary);
  font: inherit;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}

.header-user:hover {
  background-color: color-mix(in srgb, var(--el-color-primary-light-8) 85%, transparent);
}

.header-user__name {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-user__arrow {
  font-size: 12px;
}

/* E-mail сверху меню: видно, под какой учёткой вход */
.header-user__email {
  max-width: 260px;
  padding: 8px 16px 2px;
  overflow: hidden;
  font-size: 12px;
  color: var(--el-text-color-secondary);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-user__admin {
  color: var(--sd-red);
}

/* Значок кабинета рядом с корзиной на телефоне */
.mobile-user {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 36px;
  height: 36px;
  font-size: 22px;
  color: var(--el-text-color-primary);
}

/* Корзина и кабинет в правой части шапки */
.header-account {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 6px;
  white-space: nowrap;
}

/* Вторая строка под шапкой: реклама про опт всегда здесь, Тел/Email —
   только при нехватке ширины (см. isHeadOverflow в template) */
.header-subline {
  display: flex;
  flex-wrap: wrap;
  /* Реклама слева, город справа: в основной строке шапки места уже нет */
  justify-content: space-between;
  align-items: center;
  gap: 2px 12px;
  padding: 2px 12px 6px;
  font-size: 12px;
  white-space: nowrap;
  background-color: color-mix(in srgb, var(--el-bg-color) 80%, transparent);
  backdrop-filter: saturate(50%) blur(4px);
  border-top: 1px solid var(--el-border-color-lighter);
}

.header-subline__left {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 8px;
  min-width: 0;
}

.header-subline__promo {
  color: var(--el-color-primary);
}

.header-subline__sep {
  color: var(--el-border-color);
}

a {
  text-decoration: none;
}

.el-menu-demo {
  background-color: color-mix(in srgb, var(--el-bg-color) 80%, transparent);
  backdrop-filter: saturate(50%) blur(4px);
}

.menu-spacer {
  padding: 0 3px;
}

.menu-link {
  white-space: nowrap;
  color: var(--el-color-primary);
  font-weight: 500;
}
</style>
